import { styled } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

import { ShipmentOrderStatus } from "./Badge";

export const ShipmentOrderStatusBadge = styled(ShipmentOrderStatus)(() => ({
  justifyContent: "flex-start",
}));

export const BookingOrderReferenceRow = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "15px",
}));

const styles = makeStyles(() => ({
  mainDiv: {
    minHeight: "inherit",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  grid: {
    "& .MuiTableContainer-root": {
      overflowY: "hidden",
    },
  },
  ssccQuantity: {
    font: "normal 700 20px Manrope",
  },
  leftMargin: {
    marginLeft: "8px",
  },
  button: {
    cursor: "pointer",
  },
  totalQuantity: {
    width: "max-content",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    border: "1px solid #E4E7EC",
    borderRadius: "8px",
    gap: "8px",
    padding: "6px 12px",
    font: "normal 600 18px/24px Manrope",
    color: "#465869",
  },
  totalQuantityLabel: {
    font: "normal 700 20px/24px Manrope",
  },

  actionButtons: {
    marginTop: 12,
    width: "100%",
  },
  buttonOff: {
    cursor: "auto",
    "& svg": {
      color: "rgba(	71, 84, 103, 0.5) !important",
    },
  },
  saveAndBook: {
    color: "#32D583",
    border: "1px solid #32D583",
    backgroundColor: "transparent",
    "&:hover": {
      color: "#6CE9A6",
      borderColor: "#6CE9A6",
      backgroundColor: "transparent",
    },
    "&:active": {
      border: "none",
    },
    "&:disabled": {
      border: "none",
    },
  },
  addOrder: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    whiteSpace: "nowrap",
  },
  tooltipTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "4px",
    whiteSpace: "nowrap",
  },
  tooltipContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  },
}));

export default styles;
